/**
 * Invite Reminders API
 *
 * API client for invite reminder endpoints.
 */

import api from '../services/api';
import { AxiosRequestConfig } from 'axios';

export const inviteReminderAPI = {
  /**
   * Get invite reminder status for an organization
   */
  getReminderStatus: async (organizationId: string) => {
    return api.get(`/invite-reminders/status?organizationId=${organizationId}`);
  },

  /**
   * Mark that the user has seen the reminder
   */
  markReminderShown: async () => {
    return api.post('/invite-reminders/mark-shown');
  },

  /**
   * Permanently dismiss all invite reminders
   */
  dismissReminder: async () => {
    return api.post('/invite-reminders/dismiss');
  },

  /**
   * Check if inline prompt should be shown
   */
  checkInlinePrompt: async (organizationId: string, context: string) => {
    return api.get(`/invite-reminders/inline-prompt/${organizationId}?context=${context}`);
  },

  /**
   * Permanently dismiss a specific invite reminder context
   */
  dismissPermanently: async (organizationId: string, context: string) => {
    return api.post('/invite-reminders/dismiss-permanently', {
      organizationId,
      context,
    });
  },

  /**
   * Get user's reminder frequency preference
   */
  getReminderFrequency: async (config?: AxiosRequestConfig) => {
    return api.get('/invite-reminders/frequency', config);
  },

  /**
   * Set user's reminder frequency preference
   */
  setReminderFrequency: async (frequency: string) => {
    return api.put('/invite-reminders/frequency', { frequency });
  },
};
